import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

import { canManageWorkspaces, getSession, isAdmin, isWorkspaceAdmin } from "../auth/session";
import "./AppLayout.css";

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const session = getSession();
  const admin = isAdmin(session);
  const workspaceAdmin = isWorkspaceAdmin(session);
  const manageWorkspaces = canManageWorkspaces(session);
  const currentYear = new Date().getFullYear();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);
  const toggleMobileMenu = () => setMobileMenuOpen(prev => !prev);

  return (
    <div className="app-shell">
      <button
        type="button"
        className={`app-mobile-backdrop ${mobileMenuOpen ? "is-open" : ""}`}
        onClick={closeMobileMenu}
        aria-label="Fechar menu"
      />

      <aside className={`app-sidebar ${mobileMenuOpen ? "is-open" : ""}`}>
        <div>
          <img src="/logo_magma.png" alt="Magma Planning" className="app-logo" />
          <p className="app-brand-kicker">Magma Planning</p>
          <h1 className="app-brand-title">Planejamento Estratégico</h1>
        </div>

        <nav className="app-nav">
          <NavLink to="/" end className={({ isActive }) => `app-link ${isActive ? "is-active" : ""}`} onClick={closeMobileMenu}>
            Dashboard
          </NavLink>
          <NavLink to="/planejamentos" className={({ isActive }) => `app-link ${isActive ? "is-active" : ""}`} onClick={closeMobileMenu}>
            Planejamentos
          </NavLink>
          {admin ? (
            <NavLink to="/usuarios" className={({ isActive }) => `app-link ${isActive ? "is-active" : ""}`} onClick={closeMobileMenu}>
              Usuários
            </NavLink>
          ) : null}
          {manageWorkspaces ? (
            <NavLink to="/workspaces" className={({ isActive }) => `app-link ${isActive ? "is-active" : ""}`} onClick={closeMobileMenu}>
              Workspaces
            </NavLink>
          ) : null}
        </nav>

        <div className="app-role-box">
          <p><strong>Perfil:</strong> {admin ? "Global" : workspaceAdmin ? "Administrador de Workspace" : "Usuário de Workspace"}</p>
          <button
            type="button"
            onClick={() => {
              closeMobileMenu();
              logout();
            }}
            className="app-logout"
          >
            Sair
          </button>
        </div>
      </aside>

      <section className="app-content">
        <header className="app-mobile-header">
          <button
            type="button"
            className="app-mobile-toggle"
            onClick={toggleMobileMenu}
            aria-expanded={mobileMenuOpen}
            aria-label={mobileMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            <span className="app-mobile-toggle-icon" aria-hidden="true">{mobileMenuOpen ? "×" : "☰"}</span>
          </button>
          <img src="/logo_magma.png" alt="Magma Planning" className="app-mobile-logo" />
        </header>

        <div className="app-content-body">
          <Outlet />
        </div>

        <footer className="app-footer">
          Copyright © {currentYear} Magma Consultoria. Todos os direitos reservados.
        </footer>
      </section>
    </div>
  );
}
